import { render, staticRenderFns } from "./ExplorerNavigationDrawer.vue?vue&type=template&id=2bca9874"
import script from "./ExplorerNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./ExplorerNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./ExplorerNavigationDrawer.vue?vue&type=style&index=0&id=2bca9874&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bca9874')) {
      api.createRecord('2bca9874', component.options)
    } else {
      api.reload('2bca9874', component.options)
    }
    module.hot.accept("./ExplorerNavigationDrawer.vue?vue&type=template&id=2bca9874", function () {
      api.rerender('2bca9874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Explorer/ExplorerNavigationDrawer.vue"
export default component.exports